var r=function(r,e,n){return void 0===n&&(n=""),n||(r?"Required":e?"Encouraged":"")};export{r as getPromptText};
//# sourceMappingURL=getPromptText.js.map
